import { StoreAction } from "../../@core/constants/action";

const initalState = {
  unitList: [],
  leadLabelList: [],
  events_data: [],
  events_dates: [],
  leadStatusList: [],
  leadSourceList: [],
  get_allstaff: [],
  lead_today_data: [],
  task_status: [],
  task_label: [],
  webSetting_data: [],
  customerTagList: [],
  deptSetting_data: [],
  setCountryOption: [],
  setStateOption: [],
  setCityOption: [],
  today_event_data: [],
  emailConfigurationList: [],
  reminder_meeting_data: [],
  service_status: [],
  countriesList: [],
  leaveReasonList: [],
  paymentMethodList: [],
  brochureList: [],
  filterList: {},
  webSocket: null, // First Web socket for chat and all other notifications
};

export default function (state = initalState, action) {
  switch (action.type) {
    case StoreAction.SET_WEB_SOCKET:
      return {
        ...state,
        webSocket: action.payload,
      };

    case StoreAction.GET_LEAD_LABEL: {
      return {
        ...state,
        leadLabelList: action.payload,
      };
    }
    case StoreAction.GET_LEAD_STATUS: {
      return {
        ...state,
        leadStatusList: action.payload,
      };
    }
    case StoreAction.GET_SERVICE_STATUS: {
      return {
        ...state,
        service_status: action.payload,
      };
    }
    case StoreAction.GET_CUSTOMER_TAG:
      return { ...state, customerTagList: action.payload };
    case StoreAction.GET_TODAY_LEADS: {
      return {
        ...state,
        lead_today_data: action.payload,
      };
    }
    case StoreAction.GET_ALLSTAFF_DATA:
      return {
        ...state,
        get_allstaff: action.payload,
      };
    case StoreAction.GET_LEAD_SOURCE: {
      return {
        ...state,
        leadSourceList: action.payload,
      };
    }
    case StoreAction.GET_TASK_LABEL: {
      return {
        ...state,
        task_label: action.payload,
      };
    }
    case StoreAction.GET_TASK_STATUS: {
      return {
        ...state,
        task_status: action.payload,
      };
    }
    case StoreAction.GET_WEBSETTING_DATA:
      return {
        ...state,
        webSetting_data: action.payload,
      };
    case StoreAction.GET_DEPTSETTING_DATA:
      return {
        ...state,
        deptSetting_data: action.payload,
      };
    case StoreAction.GET_CALENDER_EVENTS: {
      return {
        ...state,
        events_data: action.payload,
        events_data_loading: false,
      };
    }
    case StoreAction.GET_CALENDER_DATES: {
      return {
        ...state,
        events_dates: action.payload,
      };
    }

    case StoreAction.GET_TODAY_EVENTS: {
      return {
        ...state,
        today_event_data: action.payload,
      };
    }
    case StoreAction.GET_REMINDER_MEETING_DATA: {
      return {
        ...state,
        reminder_meeting_data: action.payload,
      };
    }
    case StoreAction.GET_EMAIL_CONFIGURATION_LIST:
      return {
        ...state,
        emailConfigurationList: action.payload,
      };
    case StoreAction.IS_GLOBAL_SEARCH_SUGGESTION_OPEN:
      return {
        ...state,
        is_Global_Search_Suggestions_open: action.payload,
      };
    case StoreAction.IS_GLOBAL_SEARCH_OPEN:
      return {
        ...state,
        is_Global_Search_open: action.payload,
      };
    case StoreAction.GET_WEB_SETTING_DATA:
      return {
        ...state,
        webSettingData: action.payload,
      };

    case StoreAction.SET_COUNTRY_OPTIONS:
      return {
        ...state,
        setCountryOption: action.payload,
      };
    case StoreAction.SET_STATE_OPTIONS:
      return {
        ...state,
        setStateOption: action.payload,
      };
    case StoreAction.SET_CITY_OPTIONS:
      return {
        ...state,
        setCityOption: action.payload,
      };
    case StoreAction.GET_LEAVE_REASON: {
      return {
        ...state,
        leaveReasonList: action.payload,
      };
    }
    case StoreAction.GET_COUNTRY_LIST: {
      return {
        ...state,
        countriesList: action.payload,
      };
    }
    case StoreAction.GET_ALL_PAYMENT_METHOD_DATA:
      return { ...state, paymentMethodList: action.payload };
    case StoreAction.GET_BROCHURE:
      return { ...state, brochureList: action.payload };
    case StoreAction.GET_FILTER:
      return { ...state, filterList: action.payload };
    default:
      return state;
  }
}
